export default __webpack_public_path__ + "static/media/dstv.bdc0eade.jpg";